import React from 'react';
import classnames from 'classnames';
import Waypoint from 'react-waypoint';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
import Button from '../../../Button';
import s from './ThreadPagination.scss';
import threadStyles from '../../CommentThread.scss';
export var ThreadPagination = function (_a) {
    var hasMore = _a.hasMore, isInfinite = _a.isInfinite, isFetching = _a.isFetching, onLoadMore = _a.onLoadMore, className = _a.className, children = _a.children;
    var isV2 = useFlag('comment_v2');
    if (!hasMore) {
        return null;
    }
    if (isInfinite) {
        return React.createElement(Waypoint, { topOffset: 100, onEnter: onLoadMore });
    }
    if (isV2) {
        return (React.createElement(Button, { view: "b3", onClick: onLoadMore, disabled: isFetching, className: classnames(s['button'], className) }, children));
    }
    return (React.createElement("div", { className: threadStyles['loadmore-container'] },
        React.createElement(Button, { view: 'b8', onClick: onLoadMore, disabled: isFetching, className: threadStyles['loadmore'] }, children)));
};
ThreadPagination.displayName = 'ThreadPagination';
export default ThreadPagination;
//# sourceMappingURL=ThreadPagination.js.map